<template>
  <div
    class="yesno"
    :class="{
      yesno_clearable: clearable,
      yesno_vertical: vertical,
    }"
  >
    <span
      v-for="[key, text] in Object.entries(options || defaultOptions)"
      :key="key"
      class="yesno__option"
      :class="{ yesno__option_active: value == key }"
      @click="onClick(key)"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {},
    clearable: {
      type: Boolean,
    },
    vertical: {
      type: Boolean,
    },
    clearValue: {
      default: null,
    },
  },
  computed: {
    defaultOptions() {
      return {
        yes: this.$t('YES'),
        no: this.$t('NO'),
      };
    },
  },
  methods: {
    onClick(key) {
      if (this.clearable && this.value === key) {
        this.$emit('input', this.clearValue);
        return;
      }

      this.$emit('input', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.yesno {
  display: flex;

  &_vertical {
    flex-direction: column;

    .yesno__option:not(:first-child) {
      margin-left: 0;
      margin-top: -1px;
    }
  }

  &_clearable {
    .yesno__option_active {
      cursor: pointer;
    }
  }

  &__option {
    text-transform: capitalize;
    padding: 6px 10px;
    flex-grow: 1;
    border: 1px solid #e5e5e5;
    position: relative;
    cursor: pointer;

    &_active {
      background-color: var(--lighter-primary);
      border-color: lighten($primary, 25);
      z-index: 1;
      cursor: default;
    }

    &:first-child {
      border-radius: 2px 0 0 2px;
    }

    &:not(:first-child) {
      margin-left: -1px;
    }

    &:last-child {
      border-radius: 0 2px 2px 0;
    }
  }
}
</style>
